import React from 'react'
import { labelMappings } from '../../utils/utils';

function CouponSummary() {
  return (
    <div>{labelMappings["COUPON_SUMMARY"]}</div>
  )
}

export default CouponSummary